import { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap'
// import { blogsDetailData } from '../../common'
import { BenefitsIcon, ConclusionIcon, QuestionMarkFillIcon, QuestionMarkOutlineIcon, RoleOfSolutionArchitectIcon } from '../../common/icons'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { getIPGeoLocation } from '../../common/GeneralUtils'
// core components
import Header from '../../components/header/header'
import Footer from '../../components/footer/footer'
import SoftwareTeamHunt from '../../components/CaseStudy/SoftwareTeamHunt'
import FrequentlyAskedQuestions from '../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'
import ContactBanner from '../../components/banner/ContactBanner'
import OurLatestBlogs from '../../components/OurLatestBlogs/OurLatestBlogs'
// import { HashLink as Link } from 'react-router-hash-link';

// import { BlogDetailsData } from '../../common/BlogDetailsData'
import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterShareButton, XIcon } from 'react-share'
import axios from 'axios'
// import BenefitsImg from '../../assets/images/blog/blog-home/blogDetails/New-Project.png'

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const SoftwareTeamHunt = Loadable(
//     lazy(() => import('../../components/CaseStudy/SoftwareTeamHunt'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const ContactBanner = Loadable(
//     lazy(() => import('../../components/banner/ContactBanner'))
// )
// const OurLatestBlogs = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/OurLatestBlogs'))
// )

const ViewBlogDetailScreen = () => {
    const location = useLocation()
    const [BlogDetailsData, setData] = useState([]);
    const { title } = location.state || {};
    // const shareUrl = `https://varahisoft.com/blog-detail?id=1`
    const shareUrl = window?.location?.href
    const [ContactPageData, setContactPageData] = useState({});
    const [blogsDetailData, setBlogsDetailData] = useState({});

    const getAllContactPageData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/contactPageData.json');
            setContactPageData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllBlogsDetailData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/blogsDetailData.json');
            setBlogsDetailData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    // console.log('---------shareUrl-->', shareUrl)
    // console.log('---------window?.location-->', window?.location)
    // console.log('---------location-->', location)
    // Parse the URL query parameters
    // const searchParams = new URLSearchParams(location.state?.title)
    // console.log('---searchParams--->', searchParams)
    // const contentId = title // Extracts the id from the URL

    // Define getCountries as an async function
    const getCurrencies = async () => {
        try {
            const res = await axios.get(`/staticDataFiles/data.json`); // Assuming no `values` parameter is required for POST request
            // Set currency state to response data
            return setData(res?.data?.find((content) => content?.bannerData?.title === title))
        } catch (err) {
            console.debug(":Values from get currencies", err);
            // let customMessage = "Currencies load failed";
            // let type = "User Information";
            // let color = "red";
            // ErrorHandle(err, setToasts, customMessage, type, color); // Error handling function
        }
    };

    // useEffect(() => {
    //     fetch('/staticDataFiles/data.json')
    //         .then((response) => {
    //             if (!response.ok) throw new Error('Network response was not ok');
    //             return response.json();
    //         })
    //         .then((jsonData) => setData(jsonData.find((content) => content?.bannerData?.title === title)))
    //         .catch((error) => console.error('Error fetching JSON:', error));
    // }, [title])

    useEffect(() => {
        getCurrencies();
        getIPGeoLocation();
        getAllBlogsDetailData();
        getAllContactPageData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title])

    // console.log('-------blogsDetailData---->', blogsDetailData)

    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper blogs_details">
                <div className="container-fluid">
                    <div className="project-page">
                        <ContactBanner
                            bannerImg={blogsDetailData?.bannerImg}
                            data={BlogDetailsData?.bannerData}
                        />
                        {BlogDetailsData ? <Container className="page-blog-content pb-3">
                            {/* <img src={BlogDetailsData?.bodyImg} className="w-100 img-fluid" alt="img" /> */}
                            <Row className="m-0">
                                <Col lg="8" md="8" sm="8">
                                    <LazyLoadImage
                                        className="w-100 img-fluid"
                                        alt={'blog-img'}
                                        // height={image.height}
                                        src={BlogDetailsData?.headerData?.image} // use normal <img> attributes as props
                                    // width={image.width}
                                    />
                                    <div className="page-top-content">
                                        <h1 className="heading">{BlogDetailsData?.headerData?.title}</h1>
                                        <p className="paragraph">{BlogDetailsData?.headerData?.paragraph}</p>
                                    </div>
                                    {/* introduction */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.introduction?.heading}</h1>
                                        {BlogDetailsData?.pageData?.introduction?.paragraph?.map((intro, introIndex) =>
                                            <p key={introIndex} className="paragraph">{intro?.text}</p>
                                        )}
                                    </div>
                                    {/* Get to know everything about solution architecture */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.aboutSolutionArchitecture?.heading}</h1>
                                        {BlogDetailsData?.pageData?.aboutSolutionArchitecture?.paragraph?.map((intro, introIndex) =>
                                            <p key={introIndex} className="paragraph">{intro?.text}</p>
                                        )}
                                    </div>
                                    {/* Do you need a custom-made application? */}
                                    <Card className='page-custom-made-application-card overflow-hidden'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div p-4'>
                                                {BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.heading && <h3 className='m-0'>{BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.heading}</h3>}
                                                {BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.headingTwo && <h3 className='m-0'>{BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.headingTwo}</h3>}
                                            </div>
                                            <div className='d-flex gap-2 pe-4'>
                                                <div className='d-flex gap-3'>
                                                    <div className='mt-2'>
                                                        <QuestionMarkOutlineIcon />
                                                    </div>
                                                    <QuestionMarkFillIcon />
                                                </div>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-13px' }}>
                                                    <QuestionMarkOutlineIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                    <div className="page-intro-content">
                                        {BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>
                                                {intro?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                    {intro?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.listData}</li>)}
                                                </ul>}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* Solution architecture – the silent hero */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.solutionArchitectureTheSilentHero?.heading}</h1>
                                        {BlogDetailsData?.pageData?.solutionArchitectureTheSilentHero?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>
                                                {intro?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                    {intro?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.listData}</li>)}
                                                </ul>}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* How does Solution Architecture help */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.howDoesSolutionArchitectureHelp?.heading}</h1>
                                        {BlogDetailsData?.pageData?.howDoesSolutionArchitectureHelp?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>
                                                {intro?.steps?.length > 0 && intro?.steps?.map((step, stepIndex) => <div key={stepIndex} className='SolutionArchitectureHelp-step-div'>
                                                    <div className='step-button mb-3' style={{ width: 'fit-content' }}>
                                                        <span>step</span>
                                                        <span>{stepIndex + 1}</span>
                                                    </div>
                                                    <h1 className="heading mb-3">{step?.title}</h1>
                                                    <p className="paragraph mb-3">{step?.paragraph}</p>
                                                    {step?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                        {step?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.list}</li>)}
                                                    </ul>}
                                                </div>)}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* What Are the Components of a Solution Architecture */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.whatAreTheComponentsOfASolutionArchitecture?.heading}</h1>
                                        {BlogDetailsData?.pageData?.whatAreTheComponentsOfASolutionArchitecture?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>

                                                {intro?.steps?.length > 0 && intro?.steps?.map((step, stepIndex) => <div key={stepIndex} className='whatAreTheComponentsOfASolutionArchitecture-step-div'>
                                                    <h4 className="heading m-0">{step?.title}</h4>
                                                    <p className="paragraph mb-3">{step?.paragraph}</p>
                                                    {step?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                        {step?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.list}</li>)}
                                                    </ul>}
                                                </div>)}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* Role of Solution Architect */}
                                    <Card className='page-custom-made-application-card overflow-hidden mt-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div px-4 py-5 w-100'>
                                                {BlogDetailsData?.pageData?.roleOfSolutionArchitect?.heading && <h2 className='m-0'>{BlogDetailsData?.pageData?.roleOfSolutionArchitect?.heading}</h2>}
                                                {/* {BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.headingTwo && <h3 className='m-0'>{BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.headingTwo}</h3>} */}
                                            </div>
                                            <div className='d-flex gap-2 pe-4 justify-content-end w-100'>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-13px' }}>
                                                    <RoleOfSolutionArchitectIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                    <div className="page-intro-content">
                                        {BlogDetailsData?.pageData?.roleOfSolutionArchitect?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>
                                                {intro?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                    {intro?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.listData}</li>)}
                                                </ul>}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* What does a solution architect do? BAITS */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.heading} <span>{BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.headingTwo}</span></h1>
                                        {BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <div className='whatAreTheComponentsOfASolutionArchitecture-step-div'>
                                                    <h4 className="heading m-0">{intro?.title}</h4>
                                                </div>
                                                <p className="paragraph">{intro?.text}</p>

                                                {intro?.steps?.length > 0 && intro?.steps?.map((step, stepIndex) => <div key={stepIndex} className='whatAreTheComponentsOfASolutionArchitecture-step-div'>
                                                    <p className="paragraph mb-3">{step?.paragraph}</p>
                                                    {step?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                        {step?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.list}</li>)}
                                                    </ul>}
                                                </div>)}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* Benefits of a Solution Architecture */}
                                    <Card className='page-custom-made-application-card overflow-hidden mt-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div px-4 py-5 w-100'>
                                                {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.heading && <h2 className='m-0'>{BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.heading}</h2>}
                                                {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.headingTwo && <h3 className='m-0'>{BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.headingTwo}</h3>}
                                            </div>
                                            <div className='d-flex gap-2 pe-4 justify-content-end w-100'>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-32px' }}>
                                                    <BenefitsIcon />
                                                    {/* <LazyLoadImage
                                                        className="w-100 img-fluid m-0"
                                                        alt={'image'}
                                                        // height={image.height}
                                                        src={BenefitsImg} // use normal <img> attributes as props
                                                    // width={image.width}
                                                    /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                    <div className="page-intro-content">
                                        {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.paragraph?.map((intro, introIndex) =>
                                            <p key={introIndex} className="paragraph">{intro?.text}</p>
                                        )}
                                        {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.steps?.length > 0 && BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.steps?.map((step, stepIndex) => <div key={stepIndex} className='whatAreTheComponentsOfASolutionArchitecture-step-div'>
                                            <h4 className="heading m-0">{step?.title}</h4>
                                            <p className="paragraph mb-3">{step?.paragraph}</p>
                                            {step?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                {step?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.list}</li>)}
                                            </ul>}
                                        </div>)}
                                    </div>
                                    {/* Conclusion */}
                                    <Card className='page-custom-made-application-card overflow-hidden mt-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div px-4 py-5 w-100'>
                                                {BlogDetailsData?.pageData?.conclusion?.heading && <h2 className='m-0'>{BlogDetailsData?.pageData?.conclusion?.heading}</h2>}
                                            </div>
                                            <div className='d-flex gap-2 pe-4 justify-content-end w-100'>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-0px' }}>
                                                    <ConclusionIcon />
                                                    {/* <LazyLoadImage
                                                        className="w-100 img-fluid m-0"
                                                        alt={'image'}
                                                        // height={image.height}
                                                        src={BenefitsImg} // use normal <img> attributes as props
                                                    // width={image.width}
                                                    /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                    <div className="page-intro-content">
                                        {BlogDetailsData?.pageData?.conclusion?.paragraph?.map((intro, introIndex) =>
                                            <p key={introIndex} className="paragraph">{intro?.text}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col lg="4" md="4" sm="4">
                                    {BlogDetailsData?.socialMediaPost && <Card className="custom_card">
                                        {BlogDetailsData?.socialMediaPost?.pageTitle && <CardHeader>{BlogDetailsData?.socialMediaPost?.pageTitle}</CardHeader>}
                                        <CardBody>
                                            <div className="round-social-icon d-flex no-block gap-2">
                                                <LinkedinShareButton url={shareUrl} title={`Linkedin`}>
                                                    <LinkedinIcon size={32} round />
                                                </LinkedinShareButton>
                                                <FacebookShareButton url={shareUrl} title={`Linkedin`}>
                                                    <FacebookIcon size={32} round />
                                                </FacebookShareButton>
                                                <TwitterShareButton url={shareUrl} title={`Linkedin`}>
                                                    <XIcon size={32} round />
                                                </TwitterShareButton>
                                            </div>
                                        </CardBody>
                                    </Card>}
                                    {BlogDetailsData?.tag && <Card className="custom_card">
                                        {BlogDetailsData?.tag?.pageTitle && <CardHeader>{BlogDetailsData?.tag?.pageTitle}</CardHeader>}
                                        {BlogDetailsData?.tag?.tags?.length > 0 && <CardBody>
                                            {BlogDetailsData?.tag?.tags?.map((tagData, index) => <p key={index} className="tag">{tagData?.title}</p>)}
                                        </CardBody>}
                                    </Card>}
                                    {BlogDetailsData?.aboutAuthor && <Card className="custom_card">
                                        {BlogDetailsData?.aboutAuthor?.pageTitle && <CardHeader>{BlogDetailsData?.aboutAuthor?.pageTitle}</CardHeader>}
                                        <CardBody>
                                            <div className="author-about">
                                                {BlogDetailsData?.aboutAuthor?.authorName && <h1>{BlogDetailsData?.aboutAuthor?.authorName}</h1>}
                                                {BlogDetailsData?.aboutAuthor?.authorContent?.map((content, index) => {
                                                    return (
                                                        <p key={index}>{content?.text}</p>
                                                    )
                                                })
                                                }
                                            </div>
                                        </CardBody>
                                        <CardFooter>Blogs By {BlogDetailsData?.aboutAuthor?.authorName}</CardFooter>
                                    </Card>}
                                </Col>
                            </Row>
                        </Container> : <Container className="page-blog-content pb-3 text-center"><p>No content found for this ID.</p></Container>}
                        <div className="our-latest-blogs position-relative overflow-hidden">
                            <div className="position-absolute" style={{ inset: 0 }}>
                                <div className="acss-lbif7z acss-b61x89"></div>
                            </div>
                            <OurLatestBlogs />
                        </div>
                        <SoftwareTeamHunt data={blogsDetailData?.softwareTeamHunt} />
                        <FrequentlyAskedQuestions
                            faqData={ContactPageData?.FrequentlyAskedQuestionsData}
                        />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

ViewBlogDetailScreen.propTypes = {
    classes: PropTypes.object,
}

export default ViewBlogDetailScreen
